import { CanActivateFn } from '@angular/router';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { AuthService } from './auth.service';
import { NgxSpinnerService } from "ngx-spinner";
import { AppService } from 'src/app/app.service';

@Injectable({
  providedIn: 'root'
})

// export const authGuard: CanActivateFn = (route, state) => {
//   return true;
// };


export class AuthGuard {
  VadlidUer = false;
  private roleLoaded = false;
  

  constructor(private authService: AuthService,private appService:AppService, private router: Router, private spinner: NgxSpinnerService) { };

  canActivate() {
    // Cache the role loading to avoid repeated API calls
    if (this.roleLoaded) {
      return true;
    }

    return this.authService.loadAuthriseUserRole().then((value:any) => {
      this.appService.processRolePermission(value.data.result)
      this.roleLoaded = true;
      return true;
    }).catch((error) => {
       this.router.navigate(['/login-failed']);
       return false;
    });
  }

}

